<!-- Only single action button -->
@if (buttons.length === 1) {
  <button
    mat-raised-button
    class="basic-btn shadow"
    (click)="onClickAction(buttons[0].action)"
    [matTooltip]="buttons[0].tooltip | translate"
    [id]="buttons[0].id"
    [attr.data-testid]="buttons[0].dataTestId"
    color="accent"
    >
    <div class="d-flex justify-content-start align-items-center">
      @if (buttons[0].loading) {
        <mat-spinner diameter="25"></mat-spinner>
      }
      @if (!buttons[0].loading) {
        <mat-icon>{{ buttons[0].icon }}</mat-icon>
      }
      <p class="btn-text">
        {{ buttons[0].tooltip | translate }}
      </p>
    </div>
  </button>
}

@if (buttons.length > 1) {
  <eco-fab-speed-dial
    #fab
    class="fab-button"
    [style.right]="rightAlign + 'px'"
    style="transition: all 0.3s ease"
    >
    <eco-fab-speed-dial-trigger [spin]="true">
      <button
        mat-fab
        color="accent"
        matTooltipPosition="left"
      matTooltip="{{
        (fab.open
          ? 'shared.speed-dial.tooltip-collapse'
          : 'shared.speed-dial.tooltip-expand'
        ) | translate
      }}  (Alt/ ⌥ + E)"
        id="speedDialButton"
        [disabled]="disabled"
        class="shadow"
        >
        <mat-icon class="spin180">add</mat-icon>
      </button>
    </eco-fab-speed-dial-trigger>
    <!-- Multiple Action buttons present -->
    <eco-fab-speed-dial-actions class="multi-btn">
      @for (button of buttons; track button) {
        <button
          [id]="button.id"
          [attr.data-testid]="button.dataTestId"
          mat-mini-fab
          color="accent"
          class="shadow rounded"
          (click)="onClickAction(button.action)"
          [disabled]="disabled || button.loading"
          >
          <div class="d-flex justify-content-start mx-2">
            @if (button.loading) {
              <mat-spinner diameter="25"></mat-spinner>
            }
            @if (!button.loading) {
              <mat-icon>{{ button.icon }}</mat-icon>
            }
            <p class="btn-text">{{ button.tooltip | translate }}</p>
          </div>
        </button>
      }
    </eco-fab-speed-dial-actions>
  </eco-fab-speed-dial>
}

<ng-keyboard-shortcuts [shortcuts]="shortcuts"></ng-keyboard-shortcuts>
